import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const Header = () => {
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 0) {
          return 600; // Reset to 10 minutes when it reaches zero
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Format time as MM:SS
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <header className="sticky top-0 z-50 w-full bg-[#8B4513] text-white shadow-md" data-id="element-119">
      <div className="container mx-auto px-4 py-2 flex justify-center items-center" data-id="element-120">
        <ClockIcon className="w-4 h-4 mr-2" data-id="element-121" />
        <p className="text-sm font-medium" data-id="element-122">
          ¡Oferta por tiempo limitado!{' '}
          <span className="ml-2 bg-[#E25822] px-2 py-1 rounded font-bold" data-id="element-123">
            {formattedTime}
          </span>
        </p>
      </div>
    </header>;
};
export default Header;